import * as React from 'react';

import { FeatureFlags } from './FeatureFlags';

export const defaultFeatureFlags: FeatureFlags = {
  metricsDataCatalogEnabled: true,
  writableFieldDescriptionsEnabled: true,
  markupEditingEnabled: true,
  personalSpaceEnabled: true,
  dqcertificationVisualDesignEnabled: false,
  fieldDescriptionInheritanceLineageEnabled: true,
  incompleteCustomSqlEnabled: true,
  publishedConnectionsLineageEnabled: true,
  databasesInProjectsEnabled: true,
};

export const FeatureFlagsContext = React.createContext<FeatureFlags>(
  defaultFeatureFlags
);

export function defaultFeatureFlagsWithOverrides(
  overrides: Partial<FeatureFlags>
): FeatureFlags {
  return {
    ...defaultFeatureFlags,
    ...overrides,
  };
}
